import UserModel from '../../../../tableEngine/Script/Game/Data/Model/UserModel';
import Lobby from '../../../System/Lobby';
import { LobbyPathName } from '../Config/LobbyPathConfig';

export default class LobbyUserModel extends UserModel {
    public init() {
        this._hallModel = Lobby.hall;
        Lobby.connection.on(LobbyPathName.Balance, (data) => {
            this.actualBalance = Lobby.currentTable?.isTrial ? data.TrialBalance : data.Balance;
        });
    }

    public async login(): Promise<void> {
        const { token, platformID } = Lobby.config;
        const { Nickname, Avatar, Balance, AccountCurrency, CurrencyRatio, AccountInfoURL, LastTable } = await Lobby.connection.send(LobbyPathName.Login, {
            Token: token,
            PlatformsID: platformID, // platformID should be 3
        });
        this._nickname = Nickname;
        this._avatar = Avatar;
        this._isTrial = !AccountInfoURL;
        this.actualBalance = Balance;
        this._currency = AccountCurrency;
        this._lastTable = LastTable;
        this._currencyRatio = CurrencyRatio || 1;
    }

    public async updateFavorite(gameID: string, gameType: string, isFavorite: boolean): Promise<boolean> {
        await Lobby.connection.send(LobbyPathName.Favorite, {
            GameID: gameID,
            GameType: `${gameType}_play`,
            IsFavorite: isFavorite,
        });
        return isFavorite;
    }
}
